import React from 'react';
import { Box, Typography } from '@mui/material';

interface CreditLineProps {
    text: string;
}

const CreditLine: React.FC<CreditLineProps> = ({ text }) => {
    return (
        <Box
            sx={{
                backgroundColor: 'grey.200',
                py: 1,
                px: 2,
                textAlign: 'center',
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    fontStyle: 'italic',
                    color: 'text.secondary',
                    textAlign: 'center',

                }}
            >
                {text}
            </Typography>
        </Box>
    );
};

export default CreditLine;